module.exports = __webpack_public_path__ + "static/graphicElementsYes-66f3f9cc36b75b15a2b27514bbaa349b.png";